import useInlineStyles from '@components/sds/useInlineStyles';
import inlineStyles from './card.module.scss?inline';

interface Props {
  readonly elevation?: 0 | 1 | 2;
  readonly clickable: boolean;
}

export default function useClassName({
  elevation = 0,
  clickable,
}: Props): string {
  const clsx = useInlineStyles(inlineStyles);

  return clsx({
    card: true,
    elevation1: elevation === 1,
    elevation2: elevation === 2,
    clickable,
  });
}
